import { Component, Inject, PLATFORM_ID, Renderer2 } from '@angular/core';
import { NavigationExtras } from '@angular/router';
import * as AOS from 'aos';
import { Title, Meta } from '@angular/platform-browser';
import { Constants } from '../../common/constants';
import { DOCUMENT, isPlatformBrowser } from '@angular/common';
import { SeoService } from 'src/app/common/seo.service';



@Component({
  selector: 'app-sensor-manufacturing-managed-services-casestudy',
  templateUrl: './sensor-manufacturing-managed-services-casestudy.component.html',
  styleUrls: ['./sensor-manufacturing-managed-services-casestudy.component.css']
})
export class SensorManufacturingManagedServicesCasestudyComponent {
  router: any;
  currentUrl !: string;
  

  isOpen: boolean[] = [];
  isAdditionalOpen: boolean[] = [];
  isBrowser: boolean = false;
  baseUrl = Constants.baseUrl;
  constructor(
    private titleService: Title, 
    @Inject(PLATFORM_ID) private platformId: any,
    private _renderer2: Renderer2,private seoService:SeoService,
    @Inject(DOCUMENT) private _document: Document,
    private metaService: Meta
  ) {
    this.isBrowser = isPlatformBrowser(this.platformId);
  }



  navigateToEventForm() {
    let navigationExtras: NavigationExtras = {
      fragment: 'eventForm'
    };
    this.router.navigate([this.currentUrl], navigationExtras);
  }
  ngOnInit() {
    let script = this._renderer2.createElement('script');
    script.type = `application/ld+json`;
    script.text = `
{
  "@context": "https://schema.org",
  "@type": "Article",
  "mainEntityOfPage": {
    "@type": "WebPage",
    "@id": "https://mitresource.com/sensor_manufacturing_managed_services_casestudy/"
  },
  "headline": "Supercharge with Cloud & Automation",
  "description": "Learn how Maganti IT partnered with a manufacturing client to build a resilient and future-ready, strategy-driven cloud infrastructure.",
  "image": "https://mitresource.com/wp-content/themes/magantiWeb/assets/images/managedservicesensor/ManagedServicesSensors_mobile-Banner.png",  
  "author": {
    "@type": "Organization",
    "name": "Maganti IT Resources",
    "url": "https://mitresource.com/"
  },  
  "publisher": {
    "@type": "Organization",
    "name": "Maganti IT",
    "logo": {
      "@type": "ImageObject",
      "url": "https://mitresource.com/wp-content/themes/magantiWeb/assets/images/homepage/update-mitimage.png"
    }
  },
  "datePublished": "2023-11-15"
}`;
   
    this._renderer2.appendChild(this._document.head, script);
    this.setTitleAndMetaTags();
    this.seoService.createLinkForCanonicalURL();
    if (this.isBrowser) {
      AOS.init({ disable: 'mobile' });
    }
    this.isOpen = new Array(this.accordionItems.length).fill(false);
    this.isAdditionalOpen = new Array(this.additionalaccordionItems.length).fill(false);
  }
//   ngOnInit() {
//     if(this.isBrowser){     
//   AOS.init({disable:  
// 'mobile'});

    

  //   document.addEventListener("DOMContentLoaded", () => {
  //     const accordionHeads = document.querySelectorAll(".accordion_head");
 
  //     accordionHeads.forEach((accordionHead) => {
  //         accordionHead.addEventListener("click", function(this: HTMLElement) {
  //             const accordionBody = this.nextElementSibling as HTMLElement;
  //             const plusMinus = this.querySelector(".plusminus") as HTMLElement;
 
  //             const allAccordionBodies = document.querySelectorAll(".accordion_body");
  //             allAccordionBodies.forEach((body) => {
  //                 if (body !== accordionBody && (body as HTMLElement).style.display === 'block') {
  //                     (body as HTMLElement).style.display = 'none';
  //                     const plusMinusText = (body as HTMLElement).previousElementSibling?.querySelector(".plusminus") as HTMLElement;
  //                     if (plusMinusText) {
  //                         plusMinusText.textContent = '+';
  //                     }
  //                 }
  //             });
 
  //             if (window.getComputedStyle(accordionBody).display === 'block') {
  //                 accordionBody.style.display = 'none';
  //                 plusMinus.textContent = '+';
  //             } else {
  //                 accordionBody.style.display = 'block';
  //                 plusMinus.textContent = '-';
  //             }
  //         });
  //     });
  // });}
  // this.setTitleAndMetaTags();
  // }
 

  // isOpen: boolean[] = Array(7).fill(false); 

  // toggleAccordion(index: number) {
  //   this.isOpen[index] = !this.isOpen[index];
  // }
  scrollToSection(sectionId: string) {
    if(this.isBrowser){     

    const element = document.getElementById(sectionId);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }}
  }
  private setTitleAndMetaTags(): void {
    this.titleService.setTitle('Application modernization and migration in action - Sensor manufacturing case study');

    this.metaService.addTags([
      { name: 'description', content: 'Being technologically outdated or relying on obsolete systems can hinder the customer experience, ultimately impacting competitiveness!' },
      { property: 'og:type', content: 'website' },
      { property: 'og:title', content: 'Application modernization and migration in action - Sensor manufacturing case study' },
      { property: 'og:url', content: 'https://mitresource.com/sensor_manufacturing_managed_services_casestudy/' },
      { property: 'og:image', content: 'https://mitresource.com/assets/images/managedservicesensor/Proccess_design.png' },
       { property: 'og:description', content: 'Being technologically outdated or relying on obsolete systems can hinder the customer experience, ultimately impacting competitiveness.' },
      ]);
  }
  accordionItems = [
    { title: 'Full Environment Managed Services', content: 'Our comprehensive Full Environment Managed Services provided end-to-end solutions, ensuring that every aspect of the environment was expertly handled. From optimizing costs to implementing robust CI/CD DevOps in the cloud, our services covered the entire spectrum of managing the digital infrastructure.' },
    { title: 'Optimized Environment', content: 'Our focus on an optimized environment was two-fold. Firstly, we implemented cost optimization strategies, resulting in a resource-optimized framework that led to a whooping 50% reduction in management costs. This not only ensured financial efficiency but also streamlined operations for enhanced productivity.' },
    { title: 'CI/CD DevOps Cloud', content: 'We seamlessly integrated Continuous Integration and Continuous Deployment (CI/CD) practices within our DevOps framework in the cloud. This agile methodology accelerated software development and delivery cycles, fostering innovation and ensuring that applications were always at the forefront of industry standards.' },
    { title: 'Catalog/Portal Development', content: 'We went beyond infrastructure management to deliver a user-centric experience through the development of a robust catalog/portal. This highly available, multilingual solution became the gateway for users, offering seamless navigation and access to services.' },
    { title: 'Redundancy Management', content: 'To fortify the infrastructure against potential disruptions, we meticulously took care of redundancy. This proactive approach ensured high availability and minimized downtime, providing a resilient foundation for digital assets.' }
  ];

  additionalaccordionItems = [
    { title: 'Scalable, Zone-Redundant Solution', content: 'By implementing a zone-redundant solution, we elevated availability from 90% to an impressive 99%. This ensured that services were consistently accessible, providing a reliable experience for users.' },
    { title: 'Cost Optimization', content: 'Our cost optimization strategies went beyond resource efficiency. We analyzed expenditure meticulously, identified areas for improvement, and implemented measures that not only reduced costs but also enhanced the overall value of investments.' },
    { title: 'Availability Optimization', content: 'In our pursuit of excellence, we optimized availability to ensure systems were consistently accessible. This involved a meticulous approach to infrastructure design, configuration, and management, resulting in enhanced availability that aligned with the demands of modern digital landscapes.' },
    { title: 'Integrations Built', content: 'Whether it was connecting diverse applications, services, or third-party tools, we ensured that the ecosystem operated cohesively. These integrations were tailored to align with specific business needs, promoting interoperability and maximizing the utility of the digital environment.' }
  ];




  toggleAccordion(index: number): void {
    this.isOpen = this.isOpen.map((_, i) => i === index ? !this.isOpen[i] : false);
  }

  toggleAdditionalAccordion(index: number): void {
    this.isAdditionalOpen = this.isAdditionalOpen.map((_, j) => j === index ? !this.isAdditionalOpen[j] : false);
  }
}
